import React, { Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import styled from 'styled-components'

import ForkDevTools from '../components/ForkDevTools'
import Header from '../components/Header'
import Popups from '../components/Popups'
import Web3ReactManager from '../components/Web3ReactManager'
import DarkModeQueryParamReader from '../theme/DarkModeQueryParamReader'
import Admin from './Admin'
import Landing from './Landing'
import Stats from './Stats'
import Sunset from './Sunset'

const AppWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  overflow-x: hidden;
  min-height: 100vh;
  position: relative;
`

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.bg1};
  width: 100%;
  position: relative;
  z-index: 2;
`

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 32px;
  align-items: center;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 1;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding: 16px;
    padding-top: 2rem;
  `};
`

const Marginer = styled.div`
  margin-top: 5rem;
`

const App = () => {
  return (
    <Suspense fallback={null}>
      <Route component={DarkModeQueryParamReader} />

      <Switch>
        <Route exact path="/" component={Landing} />
        <Route>
          <AppWrapper>
            <HeaderWrapper>
              <Header />
            </HeaderWrapper>

            <BodyWrapper>
              <Popups />
              <Web3ReactManager>
                <Switch>
                  <Route exact path="/legacy" component={Sunset} />
                  <Route exact path="/stats" component={Stats} />
                  {process.env.REACT_APP_ENVIRONMENT !== 'production' && (
                    <Route exact path="/admin" component={Admin} />
                  )}
                  <Redirect to="/legacy" />
                </Switch>
              </Web3ReactManager>
              <Marginer />
            </BodyWrapper>

            {/* Dev-only fork testing tools - only renders when REACT_APP_FORK_MODE=true */}
            <ForkDevTools />
          </AppWrapper>
        </Route>
      </Switch>
    </Suspense>
  )
}

export default App
